import Http from "./base-http";

class TaskAssignment extends Http {
  updateTaskAssignment(id,data) {
    return this.client.put(`/${id}`,data)
  }
}

const taskAssignmentObj = new TaskAssignment({
  modelUrlPrefix : "TaskAssignment"
});

export default taskAssignmentObj